import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DefaultScrollWithHeaderContent from "../../../../utils/DefaultScrollWithHeaderContent";
import MyTable from '../../../../utils/MyTable';
import clsx from 'clsx';

import { useDispatch, useSelector } from "react-redux";

//Import excel
import { forwardRef, useImperativeHandle } from "react";
import allActions from "../../../../../actions";
import { headerSearch } from "../../../../../assets/styles/unoTheme";
import { applyMaskAmount, getFirstAndEndDateByMonthAndYear, getFirstPtDayOfYear, getLastPtDayMonth } from "../../../../utils/utils";
import { getDataToReturnsByArticlesReport, getDataToReturnsByAssetsReport, getRawDataToTargetsReport } from "../../../../../controllers/ReportController";
import { useMemo } from "react";
import { getRegimeLabel, parseRegimeValue } from "../../../../utils/accountRegimes";

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  green: {
    color: 'green'
  },
  red: {
    color: 'red',
  },
  headerSearch: headerSearch,
  inputSearch: {
    width: "300px",
    background: "white"
  },
  toStickyHeader: {
    display: 'flex',
    height: '100%',
  },
  tableColumn: {
    display: 'flex',
    justifyContent: "center",
    alignItems: 'center',
  },
  noRadiusBottom: {
    "& .MuiTableCell-root:first-child": {
      borderBottomLeftRadius: "0px !important",
    },
    "& .MuiTableCell-root:last-child": {
      borderBottomRightRadius: "0px !important",
    },
  },
  noRadiusTop: {
    "& .MuiTableCell-root:first-child": {
      borderTopLeftRadius: "0px !important",
    },
    "& .MuiTableCell-root:last-child": {
      borderTopRightRadius: "0px !important",
    },
  },
});

const ArticlesTab = forwardRef((props, ref) => {

  const classes = useStyles();
  const dispatch = useDispatch();

  const { segregationSelected } = props;
  const accountRegimeId = parseRegimeValue(segregationSelected);

  const clientOn = useSelector(state => state.clientOn)
  const [data, setData] = useState([]);

  const [innerLoad, setInnerLoad] = useState({
    emptyMessage: "",
    loadMessage: "Carregando retornos globais...",
    size: "small"
  })

  async function loadData(client, regimeId, isCancelled) {
    try {
      const startDate = getFirstPtDayOfYear(client.selectedPortfolioYear);
      const endDate = getLastPtDayMonth(client.selectedPortfolioMonth, client.selectedPortfolioYear);

      //Enquanto houver uma carga mais nova, as mensagens de progresso desta não devem aparecer
      const setInnerLoadIfCurrent = (value) => {
        if (!isCancelled()) setInnerLoad(value);
      };

      const returnsByArticles = await getDataToReturnsByArticlesReport(client, startDate, endDate, setInnerLoadIfCurrent, regimeId)

      //Outra segregação/cliente foi selecionado enquanto esta carga estava em andamento
      if (isCancelled()) return;

      setData(returnsByArticles?.data ?? []);

      if (!returnsByArticles?.data?.length) {
        setInnerLoad({ emptyMessage: "Nenhum ativo encontrado no período para a segregação selecionada" });
      }

    } catch (e) {
      console.log(e);
    }
  }

  function makeReport() {
    if (!data) return;
    const reportType = 'myReturnsByArticles';

    dispatch(allActions.reportLoadActions.setReportLoad({
      show: true,
      reportType,
      reportData: data,
      regimeLabel: accountRegimeId ? getRegimeLabel(accountRegimeId) : null,
      message: 'Gerando relatório...'
    }));
  }

  useImperativeHandle(ref, () => ({
    doPdfReport() {
      makeReport();
    }
  }));

  const headAndBodyTable = useMemo(() => {

    if (!data) return [];
    const nodes = [];

    for (let index = 0; index < data.length; index++) {
      const group = data[index];




      nodes.push(
        <TableHead key={`head-article-${index}`}>
          <TableRow key={`head1-article-${index}`} className="smallPadding mainColor">
            <TableCell align="center" colSpan={10}>
              {group.article_to_show || "SEM_ARTIGO"}
            </TableCell>

          </TableRow>
          <TableRow key={`head3-article-${index}`} className="smallPadding grayColor">
            <TableCell align="left">
              Ativo
            </TableCell>
            <TableCell align="right">
              Saldo Anterior
            </TableCell>
            <TableCell align="right">
              Aplicações
            </TableCell>
            <TableCell align="right">
              Resgates
            </TableCell>
            <TableCell align="right">
              Amortização
            </TableCell>
            <TableCell align="right">
              Saldo Atual
            </TableCell>
            <TableCell align="right">
              Retorno Mês
            </TableCell>
            <TableCell align="right">
              Financeiro Mês
            </TableCell>
            <TableCell align="right">
              Retorno Ano
            </TableCell>
            <TableCell align="right">
              Financeiro Ano
            </TableCell>
          </TableRow>
        </TableHead>
      )
      nodes.push(
        <TableBody key={`body-article-${index}`}>
          {Array.isArray(group.funds) && group.funds.map((row, index) => (
            <TableRow key={`body-row-article-${index}`}>
              <TableCell align="left" className={'ellipsis smallFont'}>
                {row.fund_name}
              </TableCell>
              <TableCell align="right" className="smallFont">
                {row.balanceBefore}
              </TableCell>
              <TableCell align="right" className="smallFont">
                {row.applications}
              </TableCell>
              <TableCell align="right" className="smallFont">
                {row.rescues}
              </TableCell>
              <TableCell align="right" className="smallFont">
                {row.amortization}
              </TableCell>
              <TableCell align="right" className="smallFont">
                {row.balanceNow}
              </TableCell>
              <TableCell align="right" className="smallFont">
                {row.returnMonthPercent}
              </TableCell>
              <TableCell align="right" className="smallFont">
                {row.returnMonth}
              </TableCell>
              <TableCell align="right" className="smallFont">
                {row.returnYearPercent}
              </TableCell>
              <TableCell align="right" className="smallFont">
                {row.returnYear}
              </TableCell>
            </TableRow>

          ))}

          <TableRow
            key={`target-row-article-${index}`}
            className={clsx("grayColor", classes.noRadiusBottom)}>
            <TableCell align="left" className={'ellipsis smallFont'}>
              Total
            </TableCell>
            <TableCell align="right" className="smallFont">
              {group.totalBalanceBefore}
            </TableCell>
            <TableCell align="right" className="smallFont">
              {group.totalApplications}
            </TableCell>
            <TableCell align="right" className="smallFont">
              {group.totalRescues}
            </TableCell>
            <TableCell align="right" className="smallFont">
              {group.totalAmortization}
            </TableCell>
            <TableCell align="right" className="smallFont">
              {group.totalBalanceNow}
            </TableCell>
            <TableCell align="right" className="smallFont">
              {group.totalReturnMonthPercent}
            </TableCell>
            <TableCell align="right" className="smallFont">
              {group.totalReturnMonth}
            </TableCell>
            <TableCell align="right" className="smallFont">
              {group.totalReturnYearPercent}
            </TableCell>
            <TableCell align="right" className="smallFont">
              {group.totalReturnYear}
            </TableCell>
          </TableRow>

          <TableRow
            key={`target-row-article-${index}`}
            className={clsx("grayColor", classes.noRadiusTop)}
          >
            <TableCell align="left" className={'ellipsis smallFont'}>
              Meta Atuarial
            </TableCell>
            <TableCell align="right" className="smallFont">
              -
            </TableCell>
            <TableCell align="right" className="smallFont">
              -
            </TableCell>
            <TableCell align="right" className="smallFont">
              -
            </TableCell>
            <TableCell align="right" className="smallFont">
              -
            </TableCell>
            <TableCell align="right" className="smallFont">
              -
            </TableCell>
            <TableCell align="right" className="smallFont">
              {group.actuarialTargetMonth}
            </TableCell>
            <TableCell align="right" className="smallFont">
              -
            </TableCell>
            <TableCell align="right" className="smallFont">
              {group.actuarialTargetYear}
            </TableCell>
            <TableCell align="right" className="smallFont">
              -
            </TableCell>
          </TableRow>
        </TableBody>
      )
    }

    return nodes;
  }, [data])

  useEffect(() => {
    if (clientOn && clientOn.client && clientOn.client.id
      && clientOn.client.selectedPortfolioMonth && clientOn.client.selectedPortfolioYear) {
      let cancelled = false;

      setData([]);
      setInnerLoad({
        loadMessage: "Carregando retornos por enquadramento...",
        size: "small"
      });
      loadData(clientOn.client, accountRegimeId, () => cancelled);

      return () => { cancelled = true; };
    } else {
      setInnerLoad({
        emptyMessage: "Os retornos se dão a partir do lançamento de pelo menos um mês de carteira",
      })

    }
  }, [clientOn, accountRegimeId]);

  return (
    <div className={classes.root}>

      <DefaultScrollWithHeaderContent innerLoad={innerLoad}>
        <MyTable
          stickyHeader
          size="small">
          <colgroup>

            <col width="10%" />

          </colgroup>

          {headAndBodyTable}

        </MyTable>
      </DefaultScrollWithHeaderContent>
    </div >
  );
})

export default ArticlesTab;



